export class LoraMetadata {
  timestamp?: Date;
  rssi?: number;
  snr?: number;
  data?: any;
}
